module.exports = __webpack_public_path__ + "media/icons/sentiment_dissatisfied-91c816ad.svg";